import React from "react";

export default function JoinCommunity() {
    return (
        <div className="community" id="community">
        <div className="container">
          <div className="content">
            <h1 className="title">JOIN THE COMMUNITY!</h1>
            <p className="description">Ready to be an Alpha? Join us on Discord and be part of this adventure.</p>
            <a href="https://discord.com/invite/alpha" target="_blank" className="join-discord"> Join Discord </a>
          </div>
        </div>
      </div>
    );
  }
  